import { useEffect, useMemo, useState } from 'react'
import SearchableSelect from '@/components/SearchableSelect'
import { listPurchasingPackValues } from '@/services/purchasing'
import { mergePackValueOptions } from '@/pages/purchasing/purchasingPackSelectHelpers'

export type PurchasingPackSelectProps = {
  value: string
  onChange: (packText: string) => void
  onCommit?: () => void
  id?: string
  preferBelow?: boolean
  disabled?: boolean
  className?: string
}

export default function PurchasingPackSelect({
  value,
  onChange,
  onCommit,
  id,
  preferBelow = false,
  disabled = false,
  className,
}: PurchasingPackSelectProps) {
  const [apiValues, setApiValues] = useState<{ value: string }[]>([])

  useEffect(() => {
    let cancelled = false
    void listPurchasingPackValues({ limit: 500 })
      .then((res) => {
        if (!cancelled) setApiValues(res.values)
      })
      .catch(() => {
        if (!cancelled) setApiValues([])
      })
    return () => {
      cancelled = true
    }
  }, [])

  const options = useMemo(() => mergePackValueOptions(apiValues, value), [apiValues, value])

  return (
    <SearchableSelect
      id={id}
      className={className}
      options={options}
      value={value || null}
      onChange={(nextId, label) => {
        onChange(label ?? nextId ?? '')
        if (onCommit) window.setTimeout(onCommit, 0)
      }}
      placeholder="Select pack…"
      disabled={disabled}
      allowCreate
      onCreateNew={async (name) => ({ id: name, label: name })}
      allowClear
      preferBelow={preferBelow}
    />
  )
}
